import { render, staticRenderFns } from "./OddMargin.vue?vue&type=template&id=6ce739cc&scoped=true&"
import script from "./OddMargin.vue?vue&type=script&lang=js&"
export * from "./OddMargin.vue?vue&type=script&lang=js&"
import style0 from "./OddMargin.vue?vue&type=style&index=0&id=6ce739cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce739cc",
  null
  
)

export default component.exports